import { Instagram, Linkedin, Send } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white py-8 md:py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Mobile Layout - Simplified & Centered */}
        <div className="md:hidden">
          {/* Logo & Social centered */}
          <div className="flex flex-col items-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-mejora-1/artifacts/57ti89k7_PFP-ACCRETEION-NEGATIVO.png"
              alt="Accretion Axiom Capital"
              className="h-16 w-auto mb-3"
            />
            <h3 className="text-xs font-bold tracking-wide text-center text-gray-300">ACCRETION AXIOM CAPITAL</h3>
          </div>
          
          {/* Socials centered */}
          <div className="flex justify-center gap-6 mb-5">
            <a href="https://t.me/+gbLD_8i3AbIzMTY0" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">
              <Send size={18} />
            </a>
            <a href="https://www.linkedin.com/company/accretion-axiom-capital/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">
              <Linkedin size={18} />
            </a>
            <a href="https://www.instagram.com/accretion.capital/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">
              <Instagram size={18} />
            </a>
          </div>
          
          {/* Links - single row */}
          <div className="flex justify-center gap-4 text-xs text-gray-500 mb-4">
            <a href="/realestate" className="hover:text-white">Real Estate</a>
            <span className="text-gray-700">|</span>
            <a href="/quantitative" className="hover:text-white">Quantitative</a>
            <span className="text-gray-700">|</span>
            <a href="/all-services" className="hover:text-white">Services</a>
          </div>
          
          {/* Copyright, Terms, Privacy - same line */}
          <div className="flex justify-center items-center gap-3 text-[10px] text-gray-600">
            <span>© 2025 Accretion Axiom Capital</span>
            <span>·</span>
            <a href="#" className="hover:text-white">Privacy</a>
            <span>·</span>
            <a href="#" className="hover:text-white">Terms</a>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:grid grid-cols-12 gap-8 mb-8">
          <div className="col-span-6 flex items-start gap-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-mejora-1/artifacts/57ti89k7_PFP-ACCRETEION-NEGATIVO.png"
              alt="Accretion Axiom Capital"
              className="h-56 w-auto flex-shrink-0"
            />
            <div className="pt-6">
              <h3 className="text-xl font-bold mb-3 tracking-wide">ACCRETION AXIOM CAPITAL</h3>
              <p className="text-gray-400 text-sm mb-4 leading-relaxed max-w-sm">
                Institutional-grade real estate and quantitative strategies. Democratizing access to high-yield investments.
              </p>
              <div className="flex space-x-4">
                <a href="https://t.me/+gbLD_8i3AbIzMTY0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  <Send size={20} />
                </a>
                <a href="https://www.linkedin.com/company/accretion-axiom-capital/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  <Linkedin size={20} />
                </a>
                <a href="https://www.instagram.com/accretion.capital/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
          <div className="col-span-1"></div>
          <div className="col-span-2">
            <h4 className="font-semibold mb-4 text-sm tracking-wider">SERVICES</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/invest" className="hover:text-white transition-colors">Real Estate</a></li>
              <li><a href="/quantitative" className="hover:text-white transition-colors">Quantitative</a></li>
              <li><a href="/all-services" className="hover:text-white transition-colors">All Services</a></li>
            </ul>
          </div>
          <div className="col-span-2">
            <h4 className="font-semibold mb-4 text-sm tracking-wider">COMPANY</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/#investor-form" className="hover:text-white transition-colors">Investors</a></li>
              <li><a href="/#contact" className="hover:text-white transition-colors">Contact</a></li>
              <li>Marbella, Spain</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar - Solo desktop */}
        <div className="hidden md:flex border-t border-gray-800 pt-6 flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-xs">© 2025 Accretion Axiom Capital</p>
          <div className="flex space-x-4 mt-3 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-white text-xs">Privacy</a>
            <a href="#" className="text-gray-500 hover:text-white text-xs">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
